import XLSX from "xlsx";
import FileSaver from 'file-saver';
import { oldTimeZoneMapper, handleBlankValue } from "../../common/commonUtils";

export function downloadPendingReconDetailsExcel(dataForExcel) {

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    let pendingReconDetailList = []
    if (dataForExcel && dataForExcel.paymentInfo.overallPendingReconBreakdownList && dataForExcel.paymentInfo.overallPendingReconBreakdownList.length === 0) {
        pendingReconDetailList.push({
            DateTime: null,
            TrackingId: null,
            Amount: null,
            PaymentType: null

        });
    } else {

        pendingReconDetailList = dataForExcel.paymentInfo.overallPendingReconBreakdownList.map(list => {
            let dateOption = {timeZone: list.stationTimeZone ? oldTimeZoneMapper(list.stationTimeZone) : undefined};
            let date = new Date(list.moneyCollectionTime).toLocaleString('en-US', dateOption);
            return {
                TimeStampDateTime: handleBlankValue(date) || "NA",
                TrackingId: list.trackingId || "NA",
                Amount: list.amount? list.amount.value : "NA",
                PaymentType: list.paymentMethod || "NA"
            }
        });
    }

    const pendingReconDetailSheet = pendingReconDetailList;

    //Prepare xlsx output
    var today = new Date();
    var date = '-'+(today.getMonth()+1)+'-'+today.getDate()+'_'+today.getHours() + "_" + today.getMinutes();
    const fileName = "pendingReconDetailList-"+date;

    const pendingReconDetailSheetName = "Pending Reconciliation Details";
    const workBook = {SheetNames: [], Sheets: {}};
    const pendingReconDetailWorkSheet = XLSX.utils.json_to_sheet(pendingReconDetailSheet);

    workBook.SheetNames.push(pendingReconDetailSheetName);
    workBook.Sheets[pendingReconDetailSheetName] = pendingReconDetailWorkSheet;


    const excelBuffer = XLSX.write(workBook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});

    /* the saveAs call downloads a file on the local machine */
    FileSaver.saveAs(data, fileName + fileExtension);
}


// WEBPACK FOOTER //
// ./src/component/modal/driverReconciliation/pendingReconDetailsExcelDownload.js